export default __webpack_public_path__ + "static/media/dual-blade.c38909f8.png";